import Auth from "@/services/auth";

const RequiresAuth = (to,from,next) => {
  if(!Auth.loggedIn()){
    return next({
      path: '/login'
    })
  }
  return next();
}

export default RequiresAuth;